import type { SpawnPattern } from '@/types';

/**
 * Pattern thủ công cho Task 13 (6 patterns).
 *
 * Quy tắc:
 * - Same-lane gap nên >= 350ms để khoảng cách dọc đủ thoáng
 *   (phase 0 scrollSpeed=200 → 70px gap; phase 2 360 → 126px gap)
 * - Pattern duration < intervalMs phase nhỏ nhất (hiện tại 750ms phase 2)
 *   để không overlap pattern kế tiếp
 */
export const PATTERNS: readonly SpawnPattern[] = [
  // ===== Easy =====
  {
    id: 'easy_snake',
    difficulty: 'easy',
    duration: 700,
    entities: [
      { type: 'nutrient', lane: 1, delay: 0 },
      { type: 'nutrient', lane: 0, delay: 350 },
      { type: 'nutrient', lane: 1, delay: 700 },
    ],
  },
  {
    id: 'easy_zigzag',
    difficulty: 'easy',
    duration: 600,
    entities: [
      { type: 'nutrient', lane: 0, delay: 0 },
      { type: 'nutrient', lane: 1, delay: 300 },
      { type: 'nutrient', lane: 2, delay: 600 },
    ],
  },
  {
    id: 'easy_double_side',
    difficulty: 'easy',
    duration: 400,
    entities: [
      { type: 'nutrient', lane: 0, delay: 0 },
      { type: 'nutrient', lane: 2, delay: 0 },
      { type: 'nutrient', lane: 1, delay: 400 },
    ],
  },
  {
    id: 'easy_drift_far',
    difficulty: 'easy',
    duration: 700,
    entities: [
      { type: 'nutrient', lane: 0, delay: 0 },
      { type: 'nutrient', lane: 2, delay: 350 },
      { type: 'nutrient', lane: 0, delay: 700 },
    ],
  },

  // ===== Medium =====
  {
    id: 'medium_monster_mid',
    difficulty: 'medium',
    duration: 0,
    entities: [
      { type: 'nutrient', lane: 0, delay: 0 },
      { type: 'monster', lane: 1, delay: 0 },
      { type: 'nutrient', lane: 2, delay: 0 },
    ],
  },
  {
    id: 'medium_alternating',
    difficulty: 'medium',
    duration: 700,
    entities: [
      { type: 'nutrient', lane: 0, delay: 0 },
      { type: 'monster', lane: 2, delay: 230 },
      { type: 'nutrient', lane: 1, delay: 460 },
      { type: 'nutrient', lane: 2, delay: 700 },
    ],
  },
  {
    id: 'medium_drift',
    difficulty: 'medium',
    duration: 500,
    entities: [
      { type: 'monster', lane: 0, delay: 0 },
      { type: 'nutrient', lane: 1, delay: 250 },
      { type: 'nutrient', lane: 2, delay: 500 },
    ],
  },
  {
    id: 'medium_pincer',
    difficulty: 'medium',
    duration: 600,
    entities: [
      { type: 'nutrient', lane: 1, delay: 0 },
      { type: 'monster', lane: 0, delay: 300 },
      { type: 'monster', lane: 2, delay: 600 },
    ],
  },

  // ===== Hard =====
  {
    id: 'hard_force_mid',
    difficulty: 'hard',
    duration: 0,
    entities: [
      { type: 'monster', lane: 0, delay: 0 },
      { type: 'nutrient', lane: 1, delay: 0 },
      { type: 'monster', lane: 2, delay: 0 },
    ],
  },
  {
    id: 'hard_zigzag_mix',
    difficulty: 'hard',
    duration: 720,
    entities: [
      { type: 'nutrient', lane: 0, delay: 0 },
      { type: 'monster', lane: 1, delay: 180 },
      { type: 'nutrient', lane: 2, delay: 360 },
      { type: 'nutrient', lane: 1, delay: 540 },
      { type: 'monster', lane: 0, delay: 720 },
    ],
  },
  {
    id: 'hard_corridor',
    difficulty: 'hard',
    duration: 350,
    entities: [
      // Wave 1: ép voi vào giữa (monster 2 bên)
      { type: 'monster', lane: 0, delay: 0 },
      { type: 'monster', lane: 2, delay: 0 },
      // Wave 2 (350ms sau): nutrient giữa + monster 1 bên ngẫu nhiên (mirror)
      { type: 'nutrient', lane: 1, delay: 350 },
      { type: 'monster', lane: 0, delay: 350 },
    ],
  },
  {
    id: 'hard_double_threat',
    difficulty: 'hard',
    duration: 350,
    entities: [
      { type: 'monster', lane: 0, delay: 0 },
      { type: 'nutrient', lane: 1, delay: 0 },
      { type: 'monster', lane: 2, delay: 350 },
      { type: 'nutrient', lane: 1, delay: 350 },
    ],
  },
];
